export type AnswerStatus = "pending" | "rejected" | "accepted";

// AIDEV-NOTE: Firestore nemá enum stavu. `checked` říká, že to tým viděl, `was_correct` nese
// verdikt, a u nové reklamace je null. Zkontrolovaná bez true je zamítnutá, stejně to
// počítá rejectedCount v todas-app (zkontrolované − uznané). [TD-334]
export const getAnswerStatus = (checked?: boolean | null, wasCorrect?: boolean | null): AnswerStatus => {
  if (!checked) return "pending";
  return wasCorrect ? "accepted" : "rejected";
};
